<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Gestión de Vehículos</h1>
      </v-subheader>
      <v-row>
        <v-col cols="12" md="12" class="ma-0 pa-0">
          <v-row>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-menu
                v-model="menuFltFecIni"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :disabled="loading"
                    @click:append="menuFltFecIni = true"
                    append-icon="mdi-calendar"
                    class="ma-0 pa-0"
                    dense
                    hide-details
                    label="Fecha inicio registro"
                    outlined
                    placeholder="Fecha inicio registro"
                    readonly
                    v-bind="attrs"
                    v-model="fltFecInicio"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  @change="listar()"
                  @input="menuFltFecIni = false"
                  no-title
                  scrollable
                  v-model="fltFecInicio"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-menu
                v-model="menuFltFecFin"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :disabled="loading"
                    @click:append="menuFltFecFin = true"
                    append-icon="mdi-calendar"
                    class="ma-0 pa-0"
                    dense
                    hide-details
                    label="Fecha fin registro"
                    outlined
                    placeholder="Fecha fin registro"
                    readonly
                    v-bind="attrs"
                    v-model="fltFecFin"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  @change="listar()"
                  @input="menuFltFecFin = false"
                  no-title
                  scrollable
                  v-model="fltFecFin"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-select
                :disabled="loading"
                :items="itemsFltVerif"
                @change="listar()"
                class="ma-0 pa-0"
                dense
                hide-details
                item-text="descripcion"
                item-value="codigo"
                label="Verificado"
                outlined
                placeholder="Seleccione"
                v-model="fltVerif"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="11" lg="5">
              <v-text-field
                :disabled="loading"
                :placeholder="searchPlaceholder"
                @keyup.enter="listar()"
                append-icon="mdi-magnify"
                class="ma-0 pa-0"
                dense
                hide-details
                label="Búsqueda"
                outlined
                v-model="search"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="1" lg="1" class="d-flex justify-end">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="loading"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="limpiarFiltros()"
                    style="background-color: #5cbbf6;"
                  >
                    <v-icon color="white" medium>mdi-broom</v-icon>
                  </v-btn>
                </template>
                <span>Limpiar</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="12">
              <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="items"
                :loading="loading"
                :options.sync="opciones"
                :server-items-length="totalVehiculos"
                class="elevation-1"
              >
                <template v-slot:item.usuario_cliente="{ item }">
                  {{
                    item.usuario_cliente.nombres != ""
                      ? item.usuario_cliente.nombres
                      : item.usuario_cliente.username
                  }}
                </template>
                <template v-slot:item.verificado="{ item }">
                  <v-switch
                    v-if="!vista.cliente"
                    :disabled="!vista.escritura || item.verificadoLoading"
                    @change="verificar(item)"
                    class="ma-0"
                    dense
                    hide-details
                    v-model="item.verificado"
                  >
                    <template v-slot:label>
                      <v-icon
                        v-if="!item.verificadoLoading"
                        :color="item.verificado ? 'success' : 'error'"
                      >
                        {{ item.verificado ? "mdi-check" : "mdi-close" }}
                      </v-icon>
                    </template>
                  </v-switch>
                  <v-icon
                    v-else
                    :color="
                      item.verificadoLoading
                        ? ''
                        : item.verificado
                        ? 'success'
                        : 'error'
                    "
                  >
                    {{
                      item.verificadoLoading
                        ? "mdi-loading"
                        : item.verificado
                        ? "mdi-check"
                        : "mdi-close"
                    }}
                  </v-icon>
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-icon
                    v-if="vista.lectura"
                    medium
                    class="mr-2"
                    @click.stop="editar(item, false)"
                  >
                    mdi-eye
                  </v-icon>
                  <v-icon
                    v-if="vista.escritura"
                    medium
                    class="mr-2"
                    @click.stop="editar(item, true)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    v-if="vista.supresion"
                    medium
                    class="mr-2"
                    @click="eliminar(item)"
                  >
                    mdi-trash-can
                  </v-icon>
                </template>
              </v-data-table>
              <br />
              <v-btn
                v-if="vista.escritura"
                fab
                dark
                large
                color="primary"
                fixed
                right
                bottom
                @click="nuevo"
              >
                <v-icon dark>add</v-icon>
              </v-btn>
              <v-dialog v-model="dialogo.open" persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ dialogo.titulo }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <template v-if="!vista.cliente && dialogo.nuevo">
                          <v-col cols="12" sm="12" md="10" lg="8">
                            <v-autocomplete
                              :disabled="dialogo.loading"
                              :items="usuarios"
                              :loading="loadingUsuario"
                              :search-input.sync="busqueda"
                              dense
                              hide-details
                              hide-no-data
                              item-text="descripcion"
                              item-value="codigo"
                              label="Usuario"
                              outlined
                              placeholder="Nombre de cliente, DNI"
                              v-model="dialogo.usuario"
                            ></v-autocomplete>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="0"
                            md="2"
                            lg="4"
                            class="hidden-sm-and-down"
                          ></v-col>
                        </template>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            :disabled="dialogo.loading || !dialogo.edicion"
                            @input="
                              v => {
                                dialogo.placa = v.toUpperCase();
                              }
                            "
                            @keyup.enter="guardar()"
                            dense
                            hide-details
                            label="Placa"
                            outlined
                            placeholder="Placa"
                            required
                            v-model="dialogo.placa"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            :disabled="
                              dialogo.loading ||
                                !dialogo.edicion ||
                                !dialogo.nuevo
                            "
                            @input="
                              v => {
                                dialogo.serie = v.toUpperCase();
                              }
                            "
                            @keyup.enter="guardar()"
                            dense
                            hide-details
                            label="Serie"
                            outlined
                            placeholder="Serie"
                            required
                            v-model="dialogo.serie"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            disabled
                            dense
                            hide-details
                            label="Serie Fabricante"
                            outlined
                            placeholder="Serie Fabricante"
                            v-model="dialogo.serie_fabricante"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            disabled
                            dense
                            hide-details
                            label="Clase"
                            outlined
                            placeholder="Clase"
                            v-model="dialogo.clase"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            disabled
                            dense
                            hide-details
                            label="Sub Clase"
                            outlined
                            placeholder="Sub Clase"
                            v-model="dialogo.sub_clase"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            disabled
                            dense
                            hide-details
                            label="Familia"
                            outlined
                            placeholder="Familia"
                            v-model="dialogo.familia"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            disabled
                            dense
                            hide-details
                            label="Marca"
                            outlined
                            placeholder="Marca"
                            v-model="dialogo.marca"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            disabled
                            dense
                            hide-details
                            label="Modelo"
                            outlined
                            placeholder="Modelo"
                            v-model="dialogo.modelo"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            dense
                            disabled
                            hide-details
                            label="Color"
                            outlined
                            placeholder="Color"
                            v-model="dialogo.color"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            dense
                            disabled
                            hide-details
                            label="Ruedas"
                            outlined
                            placeholder="Ruedas"
                            v-model="dialogo.ruedas"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            dense
                            disabled
                            hide-details
                            label="Combustible"
                            outlined
                            placeholder="Combustible"
                            v-model="dialogo.combustible"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            dense
                            disabled
                            hide-details
                            label="Año Fabricacion"
                            outlined
                            placeholder="Año Fabricacion"
                            v-model="dialogo.ano_fabricacion"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            dense
                            disabled
                            hide-details
                            label="Año Modelo"
                            outlined
                            placeholder="Año Modelo"
                            v-model="dialogo.ano_modelo"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            dense
                            disabled
                            hide-details
                            label="Kilometraje"
                            outlined
                            placeholder="Kilometraje"
                            v-model="dialogo.kilometraje"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          v-if="!this.vista.cliente"
                        >
                          <v-textarea
                            dense
                            disabled
                            hide-details
                            label="Mensaje SAP"
                            outlined
                            placeholder="Mensaje SAP"
                            v-model="dialogo.mensajeVerif"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click.stop="cerrar()"
                      :disabled="dialogo.loading"
                    >
                      Cerrar
                    </v-btn>
                    <v-btn
                      v-if="dialogo.edicion"
                      color="blue darken-1"
                      text
                      @click.stop="guardar()"
                      :disabled="dialogo.loading"
                    >
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dlgEliminar.open" persistent max-width="350px">
                <v-card>
                  <v-card-title>
                    <span class="headline">
                      ¿Eliminar vehíchulo?
                    </span>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click.stop="cerrarDlgEliminar(false)"
                      color="blue darken-1"
                      text
                    >
                      No
                    </v-btn>
                    <v-btn
                      @click.stop="cerrarDlgEliminar(true)"
                      color="blue darken-1"
                      text
                    >
                      Si
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Vehiculos",
  data: () => ({
    usuarios: [],
    loadingUsuario: false,
    busqueda: null,
    itemsFltVerif: [
      { codigo: "0", descripcion: "Todos" },
      { codigo: "1", descripcion: "Si" },
      { codigo: "2", descripcion: "No" }
    ],
    fltVerif: "0",
    search: "",
    fltFecInicio: "",
    fltFecFin: "",
    menuFltFecIni: false,
    menuFltFecFin: false,
    searchPlaceholder: "",
    totalVehiculos: 0,
    opciones: { sortBy: ["fecha_registro"], sortDesc: [true] },
    loading: false,
    headers: [],
    items: [],
    dialogo: {
      id: 0,
      nuevo: false,
      edicion: false,
      loading: false,
      open: false,
      placa: "",
      serie: "",
      serie_fabricante: "",
      clase: "",
      sub_clase: "",
      familia: "",
      marca: "",
      modelo: "",
      color: "",
      usuario: "",
      ruedas: "",
      combustible: "",
      ano_fabricacion: "",
      ano_modelo: "",
      kilometraje: ""
    },
    dlgEliminar: {
      open: false,
      resolve: null,
      motivo: "",
      error: ""
    },
    footerProps: { "items-per-page-options": [15, 30, 50, 100] },
    vista: {}
  }),
  watch: {
    opciones: {
      handler() {
        this.listar();
      },
      deep: true
    },
    async busqueda(valor) {
      let respuesta;
      try {
        this.loadingUsuario = true;
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/BuscarUsuario?searchTerm=${valor}`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.loadingUsuario = false;
      }
      // console.log(respuesta.data);
      this.usuarios = respuesta.data.map(x => ({
        codigo: x.username,
        descripcion: x.nombres + ", " + x.documento
      }));
    }
  },
  computed: { ...mapGetters(["getToken"]) },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    limpiarFiltros() {
      this.fltVerif = "0";
      this.search = "";
      this.fltFecInicio = "";
      this.fltFecFin = "";
      this.listar();
    },
    abrirDlgEliminar() {
      return new Promise(resolve => {
        this.dlgEliminar.motivo = "";
        this.dlgEliminar.resolve = resolve;
        this.dlgEliminar.open = true;
      });
    },
    cerrarDlgEliminar(resultado) {
      this.dlgEliminar.open = false;
      this.dlgEliminar.resolve(resultado);
      this.dlgEliminar.error = "";
      this.dlgEliminar.resolve = null;
    },
    async loadVista() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ObtenerVista?vista=VEHICULOS`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      // console.log(respuesta.data);
      this.vista = respuesta.data;
    },
    async verificar(item) {
      const params = {
        id: item.id,
        placa: item.placa,
        usuario_cliente: {
          username: item.usuario_cliente.username
        },
        verificado: item.verificado
      };

      const anterior = item.verificado !== true;

      let respuesta;
      try {
        item.verificadoLoading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/vehiculo/Verificar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        item.verificadoLoading = false;
      }

      //this.listar();

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo != 0) {
        item.verificado = anterior;
      }
    },
    async listar() {
      if (this.loading) {
        return;
      }
      const { sortBy, sortDesc, page, itemsPerPage } = this.opciones;
      const params = {
        sortBy,
        sortDesc,
        page,
        itemsPerPage,
        search: this.search,
        cliente: this.vista.cliente,
        verificado: this.fltVerif === "0" ? "" : this.fltVerif === "1",
        fec_ini_registro: this.fltFecInicio,
        fec_fin_registro: this.fltFecFin
      };

      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/vehiculo/listar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }

        return;
      } finally {
        this.loading = false;
      }
      console.log(respuesta.data);
      this.totalVehiculos = respuesta.data.total;
      this.items = respuesta.data.lista.map((el, idx) => {
        return {
          ...el,
          verificadoLoading: false,
          acciones: null
        };
      });
    },
    nuevo() {
      this.dialogo.usuario = "";
      this.dialogo.nuevo = true;
      this.dialogo.edicion = true;
      this.dialogo.titulo = "Nuevo Vehículo";
      this.dialogo.placa = "";
      this.dialogo.serie = "";
      this.dialogo.serie_fabricante = "";
      this.dialogo.clase = "";
      this.dialogo.sub_clase = "";
      this.dialogo.familia = "";
      this.dialogo.marca = "";
      this.dialogo.modelo = "";
      this.dialogo.color = "";
      this.dialogo.ruedas = "";
      this.dialogo.combustible = "";
      this.dialogo.ano_fabricacion = "";
      this.dialogo.ano_modelo = "";
      this.dialogo.kilometraje = "";
      this.dialogo.mensajeVerif = "";
      this.dialogo.open = true;
    },
    editar(item, edicion) {
      // console.log(item);
      // console.log(edicion);
      if (!this.vista.cliente) {
        this.dialogo.usuario = item.usuario_cliente.username;
      }

      this.dialogo.nuevo = false;
      this.dialogo.edicion = edicion;
      this.dialogo.titulo = (edicion ? "Edición" : "Consulta") + " de Vehículo";
      this.dialogo.placa = item.placa;
      this.dialogo.serie = item.serie;
      //this.dialogo.modelo = item.modelo;
      this.dialogo.open = true;

      (async instancia => {
        let respuesta;
        try {
          respuesta = await axios.get(
            process.env.VUE_APP_BASE_PATH +
              `/api/vehiculo/obtener?vehiculoId=${item.id}`,
            { headers: { Authorization: `Bearer ${instancia.getToken}` } }
          );
          // console.log(respuesta.data);
        } catch (error) {
          if (error.response.status == 400) {
            instancia.showAlerta2({
              mensaje: error.response.data.error_description,
              tipo: 3
            });
          } else {
            instancia.salir();
          }
          return;
        }

        instancia.dialogo.id = respuesta.data.id;
        instancia.dialogo.serie_fabricante = respuesta.data.serie_fabricante;
        instancia.dialogo.clase = respuesta.data.clase;
        instancia.dialogo.sub_clase = respuesta.data.sub_clase;
        instancia.dialogo.familia = respuesta.data.familia;
        instancia.dialogo.marca = respuesta.data.marca;
        instancia.dialogo.modelo = respuesta.data.modelo;
        instancia.dialogo.color = respuesta.data.color;
        instancia.dialogo.ruedas = respuesta.data.ruedas;
        instancia.dialogo.combustible = respuesta.data.combustible;
        instancia.dialogo.ano_fabricacion = respuesta.data.ano_fabricacion;
        instancia.dialogo.ano_modelo = respuesta.data.ano_modelo;
        instancia.dialogo.kilometraje = respuesta.data.kilometraje;
        instancia.dialogo.mensajeVerif = respuesta.data.mensaje_verif;
      })(this);
    },
    async guardar() {
      if (this.dialogo.nuevo) {
        if (this.dialogo.placa == "") {
          this.showAlerta2({
            mensaje: "Se requiere placa",
            tipo: 3
          });
          return;
        }

        if (this.dialogo.serie == "") {
          this.showAlerta2({
            mensaje: "Se requiere serie",
            tipo: 3
          });
          return;
        }
      }

      const params = {
        id: this.dialogo.id,
        cliente: this.vista.cliente,
        nuevo: this.dialogo.nuevo,
        placa: this.dialogo.placa,
        serie: this.dialogo.serie,
        modelo: this.dialogo.modelo,
        usuario_cliente: {
          username: this.dialogo.usuario
        }
      };

      let respuesta;
      try {
        this.dialogo.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/vehiculo/Guardar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.dialogo.loading = false;
      }

      this.listar();

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.dialogo.open = false;
      }
    },
    async eliminar(item) {
      if (!(await this.abrirDlgEliminar())) {
        return;
      }
      const params = {
        id: item.id,
        placa: item.placa,
        usuario_cliente: {
          username: this.dialogo.usuario
        }
      };

      let respuesta;
      try {
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/vehiculo/eliminar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      this.listar();
      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });
    },
    cerrar() {
      this.dialogo.open = false;
      this.dialogo.placa = "";
      this.dialogo.serie = "";
      this.dialogo.serie_fabricante = "";
      this.dialogo.clase = "";
      this.dialogo.sub_clase = "";
      this.dialogo.familia = "";
      this.dialogo.marca = "";
      this.dialogo.modelo = "";
      this.dialogo.color = "";
      this.dialogo.ruedas = "";
      this.dialogo.combustible = "";
      this.dialogo.ano_fabricacion = "";
      this.dialogo.ano_modelo = "";
      this.dialogo.kilometraje = "";
      this.dialogo.mensajeVerif = "";
      this.dialogo.usuario = null;
      this.usuarios = [];
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  async created() {
    await this.loadVista();
    // this.searchPlaceholder = "Placa, Serie, Modelo";
    this.searchPlaceholder =
      (!this.vista.cliente ? "Cliente, " : "") + "Placa, Serie, Marca, Modelo";

    let headers = [];

    headers = [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "correlativo"
      },
      { text: "Fec. Registro", value: "fecha_registro" }
    ];

    if (!this.vista.cliente) {
      headers.push({ text: "Cliente", value: "usuario_cliente" });
    }

    headers.push({ text: "Placa", value: "placa" });
    headers.push({ text: "Serie", value: "serie" });
    headers.push({ text: "Marca", value: "marca" });
    headers.push({ text: "Modelo", value: "modelo" });

    headers.push({
      text: "Verificado",
      value: "verificado",
      sortable: false
    });

    headers.push({ text: "Acciones", value: "acciones", sortable: false });

    this.headers = headers;
  }
};
</script>

<style scoped></style>
